import ivclass from '@invideoio/web-shared/Modules/IVClass';
import BackButton from '@components/back-button';
import { ROUTES } from '@constants/common';

interface TrendingPostPageHeaderPropType {
  title: string;
}

const TrendingPostPageHeader = ({ title }: TrendingPostPageHeaderPropType) => {
  return (
    <section
      className={ivclass(
        'iv-container iv-mx-auto',
        'iv-mt-[87px] lg:iv-mt-[87px] md:iv-mt-[72px] sm:iv-mt-[43px]',
        'iv-mb-[98px] lg:iv-mb-[97px] md:iv-mb-50 sm:iv-mb-50',
      )}
    >
      <div className={ivclass('iv-grid iv-grid-cols-12 iv-col-span-12')}>
        <div
          className={ivclass(
            'iv-col-start-2 lg:iv-col-start-2 md:iv-col-start-1  sm:iv-col-start-1',
            'iv-col-span-10 md:iv-col-span-12 sm:iv-col-span-12',
            'sm:iv-px-25',
            'sm:iv-leading-[49px]',
            'sm:iv-text-center',
          )}
        >
          <div
            className={ivclass(
              'iv-text-heading-4xl md:iv-text-heading-3xl sm:iv-text-heading-m ',
              'md:iv-leading-[80px]',
              'iv-text-black-85',
              'iv-px-[34px] lg:iv-px-5 md:iv-px-[70px] sm:iv-px-[0] sm:iv-pl-[4px]',
              'iv-mx-[-13px]',
              'iv-font-extrabold md:iv-font-extrabold sm:iv-font-extrabold',
              'iv-mb-[61px] xl:iv-mb-[61px] md:iv-mb-[32px] sm:iv-mb-[20px]',
            )}
          >
            {title}
          </div>
          <div
            className={ivclass(
              'sm:iv-flex sm:iv-justify-center',
              'md:iv-mr-8',
              'iv-px-20 lg:iv-px-[0] md:iv-px-[57px] sm:iv-px-[0] sm:iv-pl-[0]',
            )}
          >
            <BackButton
              isDark={true}
              buttonContent="Back to blog"
              redirectLink={ROUTES.BLOGHOMEPAGE}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrendingPostPageHeader;
